import { Component, ViewChild, OnInit, inject } from "@angular/core";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { MatDialogRef } from "@angular/material/dialog";
import { InventoryMetadataService, InventoryService } from "../../services";
import { NgForm } from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
@Component({
    selector: "add-item-metadata-dialog-component",
    templateUrl: "./addMetadataDialog.tmpl.html",
    styleUrls: ["./addMetadataDialog.component.scss"],
    standalone: false
})
export class AddItemMetadataDialogComponent implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<AddItemMetadataDialogComponent, string | undefined>>(MatDialogRef);
    private $inventoryMetadataService = inject(InventoryMetadataService);
    private $inventoryService = inject(InventoryService);

    readonly commands: Array<Command>;
    @ViewChild("form")
    form: NgForm;

    entity: unknown;
    metadataLoading: boolean;
    metadata: ClassMetadata;
    hasError: boolean;
    saveError: string;
    constructor()
    {
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => this.cancel(),
                getEnabled: () => true,
            }),
            new LabelCommand({
                type: "raised",
                label: "Save",
                action: () => this.save(),
                getEnabled: () => this.canSave(),
            }),
        ];
    }

    ngOnInit(): void
    {
        this.metadataLoading = true;
        this.entity = {};
        this.$inventoryMetadataService.GetAddInventoryMetadata().then(response =>
        {
            this.metadata = response;
            this.metadataLoading = false;
        });
    }

    canSave(): boolean
    {
        return this.form && !this.form.invalid;
    }

    cancel(): void
    {
        this.dialogRef.close();
    }

    save(): void
    {
        this.$inventoryService.SaveNewItem(this.entity).then(
            (response: string): void =>
            {
                this.dialogRef.close(response);
            },
            (err: HttpErrorResponse): void =>
            {
                this.saveError = err.error.Message;
                this.hasError = true;
            }
        );
    }
}
